import { RootState } from "src/store";

export const currentPosAgencySelector = (state:RootState) => {
    return state.pos.currentAgency
}

export const posHasCurrentAgencySelector = (state:RootState) => {
    return !!state.pos.currentAgency
}